// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { useEffect }         from 'react'
import { useNavigate }       from 'react-router-dom'
import { OnboardingWizard }  from '@/modules/onboarding/OnboardingWizard'
import { useOnboardingStore } from '@/store'
import { ROUTES }             from '@/lib/constants/routes'

export function OnboardingPage() {
  const navigate  = useNavigate()
  const { reset, isComplete } = useOnboardingStore()

  // Reset wizard on mount
  useEffect(() => {
    reset()
  }, [reset])

  // If somehow completed, redirect
  useEffect(() => {
    if (isComplete) {
      navigate(ROUTES.DASHBOARD, { replace: true })
    }
  }, [isComplete, navigate])

  return (
    <div className="w-full">
      <div className="text-center mb-6">
        <h1 className="text-xl font-semibold text-ink">Uw profiel aanmaken</h1>
        <p className="text-sm text-ink-3 mt-1">
          Uw gegevens worden veilig opgeslagen op dit apparaat.
        </p>
      </div>
      <OnboardingWizard />
    </div>
  )
}
